<template>
  <div>
    <div ref="chart" v-show="showChart" style="height: 300px">CHART</div>

    <div v-show="!showChart">
      <div class="empty-state text-center mt-5 mb-5">
        <img class="img-fluid" src="~/no_data/report-chart.png" alt="No Insights Img"
          height=150
          width=400>
        <div class="text-center text-muted mb-2">
          <h3 class="mt-4 mb-4">You don't have any data for this date range.</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Highcharts from 'highcharts'
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
import { differenceClass } from '../../../../common/helpers'

function tooltipHeader(name) {
  return `<span class="tooltip-title">${name}</span>`
}

function tooltipPoint(data, diff) {
  return '<div class="tooltip-line">' +
    `<span class="point" style="color:${data.color}">\u25CF</span>` +
    `<span class="date">${moment(data.x).format('D MMM YYYY')}</span>` +
    `<span class="value">${data.y}</span>` +
    `<span class="difference ${differenceClass(diff)}">${Math.abs(diff)}</span></div>`
}

export default {
  computed: {
    ...mapGetters(['insightsExists', 'chartData', 'compare']),
    showChart() {
      return this.chartData.length && this.chartData[0].data.length
    }
  },
  methods: mapActions(['fetchInsights']),
  watch: {
    chartData(data) {
      const tooltip = {
        backgroundColor: '#535c65',
        borderRadius: 4,
        borderWidth: 0,
        padding: 0,
        style: {
          fontSize: '14px',
          color: '#fff'
        },
        useHTML: true,
        shadow: false
      }
      if (this.compare) {
        tooltip.formatter = function formatter() {
          const i = this.series.data.indexOf(this.point)
          const memo = []
          memo.push(tooltipHeader(this.series.name))
          this.series.chart.series.reduceRight((prev, series) => {
            if (series.data[i].y !== null) {
              const diff = prev.length !== 0 ? (series.data[i].y - prev.y) : 0
              memo.push(tooltipPoint(series.data[i], diff))
            }
            return series.data[i]
          }, [])

          return memo.join('')
        }
      } else {
        tooltip.padding = 12
        tooltip.style.fontSize = '12px'
        tooltip.shared = true
        tooltip.crosshairs = true
        tooltip.xDateFormat = '%d %B %Y'
      }

      if (this.chart) this.chart.destroy()
      this.chart = Highcharts.chart(this.$refs.chart, {
        alignTicks: false,
        title: false,
        chart: { height: 300 },
        credits: { enabled: false },
        xAxis: [
          { type: 'datetime' },
          { type: 'datetime', opposite: true }
        ],
        time: { useUTC: true },
        series: data,
        tooltip: tooltip
      })
    }
  },
  mounted() {
    if (this.insightsExists) {
      this.fetchInsights()
    }
  }
}
</script>
